import { App } from 'vue';
import { createRouter, createWebHistory, Router } from 'vue-router';
import { routes } from 'vue-router/auto-routes';
import setupGuards from './guards';
import setupAnalytics from './analytics';
import setupLandingPreferenceTracking from './landing-preference';
import setupTrackingParamCarryForward from './tracking-params';

const router: Router = createRouter({
  history: createWebHistory(),
  routes,
});

setupTrackingParamCarryForward(router);

setupGuards(router);

setupLandingPreferenceTracking(router);

setupAnalytics(router);

export { router };

export default function (app: App): void {
  app.use(router);
}
